export default {
  financialInformation: 1,
  confirmId: 2,
  confirmPoa: 3,
  ibtStatus: 4,
}
